import { memo, useEffect, useRef } from 'react';

import {
  ScaffolderFormPaper,
  ScaffolderInputHeader,
} from '../../../components';
import { SourcePicker } from '../components';
import { SOURCE_INFO } from '../infoDoc';
import { SourceConfiguration } from '../types';

export interface ApplicationSetSourceSectionProps {
  value: SourceConfiguration | null;
  onChange: (value: SourceConfiguration | null) => void;
  errors: string[];
}

const ApplicationSetSourceSectionInner = ({
  value,
  onChange,
  errors,
}: ApplicationSetSourceSectionProps) => {
  const hasErrors = errors.length > 0;
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (hasErrors) {
      sectionRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [hasErrors]);

  return (
    <div ref={sectionRef}>
      <ScaffolderFormPaper>
        <ScaffolderInputHeader
          title="Source"
          description="Configure the source for this ApplicationSet's deployment."
          variant="h5"
          divider
          infoDoc={SOURCE_INFO}
        />
        <SourcePicker
          value={value}
          onChange={onChange}
          errors={errors}
          enableAppSetSupport
        />
      </ScaffolderFormPaper>
    </div>
  );
};

export const ApplicationSetSourceSection = memo(
  ApplicationSetSourceSectionInner,
);
